<template>
  <div id="piechart"
       style="height: 300px; margin:0 auto">
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'pie-charts',
  data () {
    return {
      dataset: [
        { value: 335, name: '完成治疗' },
        { value: 310, name: '正在治疗' },
        { value: 274, name: '提前终止治疗' }
      ]
    }
  },
  mounted () {
    // let that = this
    // this.drawPie(that.dataset)

  },
  methods: {
    drawPie (dataset) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('piechart'))
      // 绘制图表
      var optino = {
          tooltip : {
              trigger: 'item',
              formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          grid: {
            left: '3%',
            right: '3.5%',
            bottom: '2%',
            top:'14%',
            containLabel: true
          },
          legend: {
              x : 'center',
          },
          calculable : true,
          series : [
              {
                  name:'治疗状态',
                  type:'pie',
                  radius : [30, 110],
                  roseType : 'area',
                  data:dataset
              }
          ]
      };
      myChart.setOption(optino)
    }
  }
};
</script>
